<template>
  <div class="feed-error-report-modal">
    <div class="modal-content">
      <!-- Description section -->
      <div class="field">
        <label class="label">פירוט הטעות *</label>
        <div class="control">
          <textarea
            v-model="description"
            class="textarea"
            placeholder="אנא פרט/י את הטעות שמצאת..."
            rows="6"
            @input="errorMessage = ''"
          ></textarea>
        </div>
        <p v-if="errorMessage" class="help is-danger">{{ errorMessage }}</p>
      </div>

      <!-- Summary section -->
      <div class="summary-section">
        <h4 class="summary-title">📋 סיכום המידע שיישלח</h4>
        <div class="summary-content">
          <div class="summary-row" v-if="adminName">
            <span class="summary-label">אדמין מדווח:</span>
            <span class="summary-value">{{ adminName }}</span>
          </div>
          <div class="summary-row" v-if="operation">
            <span class="summary-label">אופרציה:</span>
            <span class="summary-value">{{ operation }}</span>
          </div>
          <div class="summary-row" v-if="offerId">
            <span class="summary-label">מספר הצעה:</span>
            <span class="summary-value">#{{ offerId }}</span>
          </div>
          <div class="summary-row" v-if="positionTitle">
            <span class="summary-label">משרה:</span>
            <span class="summary-value">{{ positionTitle }}</span>
          </div>
          <div class="summary-row" v-if="companyName">
            <span class="summary-label">חברה:</span>
            <span class="summary-value">{{ companyName }}</span>
          </div>
          <div class="summary-row" v-if="applicantName">
            <span class="summary-label">מועמד:</span>
            <span class="summary-value">{{ applicantName }}</span>
          </div>
          <div class="summary-row" v-if="taskName">
            <span class="summary-label">משימה:</span>
            <span class="summary-value">{{ taskName }}</span>
          </div>
          <div class="summary-row" v-if="subTaskName">
            <span class="summary-label">תת-משימה:</span>
            <span class="summary-value">{{ subTaskName }}</span>
          </div>
        </div>
      </div>

      <!-- Action buttons -->
      <div class="buttons-section">
        <button
          @click="submitReport"
          class="button is-danger is-medium"
          :class="{ 'is-loading': isSubmitting }"
          :disabled="isSubmitting"
        >
          <span class="icon"><span>📧</span></span>
          <span>שלח דיווח</span>
        </button>
        <button
          @click="cancel"
          class="button is-light is-medium"
          :disabled="isSubmitting"
        >
          <span>ביטול</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedErrorReportModal',
  props: {
    alert: {
      type: Object,
      default: () => null
    },
    selectedTaskName: {
      type: String,
      default: ''
    },
    selectedTaskId: {
      type: String,
      default: ''
    },
    operation: {
      type: String,
      default: ''
    },
    adminName: {
      type: String,
      default: ''
    },
    onSubmit: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      description: '',
      isSubmitting: false,
      errorMessage: ''
    }
  },
  computed: {
    offerId () {
      return (this.alert && this.alert.resources && this.alert.resources.offer && this.alert.resources.offer.id) || null
    },
    positionTitle () {
      return (this.alert && this.alert.resources && this.alert.resources.position && this.alert.resources.position.title) || null
    },
    companyName () {
      return (this.alert && this.alert.resources && this.alert.resources.company && this.alert.resources.company.name) || null
    },
    applicantName () {
      return (this.alert && this.alert.resources && this.alert.resources.applicant && this.alert.resources.applicant.full_name) || null
    },
    taskName () {
      return this.selectedTaskName || null
    },
    subTaskName () {
      // Get sub-task name for "משרה ייעודית"
      if (this.selectedTaskName === 'משרה ייעודית') {
        const storedState = localStorage.getItem('designated_position_state')
        if (storedState) {
          try {
            const parsedState = JSON.parse(storedState)
            const offerType = parsedState.offer_type
            const typeLabels = {
              'related_positions': 'משרות אחיות',
              'strong': 'סטרונג',
              'purple': 'סגול',
              'method_10': 'מטוד 10'
            }
            return typeLabels[offerType] || offerType
          } catch (e) {
            return null
          }
        }
      }
      return null
    }
  },
  methods: {
    async submitReport () {
      // Validate description
      if (!this.description || this.description.trim().length === 0) {
        this.errorMessage = 'נא למלא פירוט של הטעות'
        return
      }

      if (this.description.trim().length < 10) {
        this.errorMessage = 'הפירוט קצר מדי (מינימום 10 תווים)'
        return
      }

      this.isSubmitting = true
      this.errorMessage = ''

      try {
        const reportData = {
          description: this.description.trim(),
          operation: this.operation,
          offer_id: this.offerId,
          position_id: (this.alert && this.alert.resources && this.alert.resources.position && this.alert.resources.position.id) || null,
          position_title: this.positionTitle,
          company_id: (this.alert && this.alert.resources && this.alert.resources.company && this.alert.resources.company.id) || null,
          company_name: this.companyName,
          applicant_id: (this.alert && this.alert.resources && this.alert.resources.applicant && this.alert.resources.applicant.id) || null,
          applicant_name: this.applicantName,
          admin_name: this.adminName,
          task_name: this.taskName,
          sub_task_name: this.subTaskName
        }

        await this.$network_utils.reportFeedError(reportData)

        this.$utils.emit('show_toast', {
          text: 'הדיווח נשלח בהצלחה',
          type: 'success'
        })

        this.onSubmit(this.$parent.modal_id)
      } catch (error) {
        console.error('Error submitting feed error report:', error)
        this.$utils.emit('show_toast', {
          text: 'שגיאה בשליחת הדיווח',
          type: 'error'
        })
      } finally {
        this.isSubmitting = false
      }
    },
    cancel () {
      this.onSubmit(this.$parent.modal_id)
    }
  }
}
</script>

<style scoped>
.feed-error-report-modal {
  padding: 1.5rem;
  direction: rtl;
}

.modal-content {
  max-width: 100%;
}

/* Field styling */
.field {
  margin-bottom: 1.5rem;
}

.label {
  font-weight: 700;
  font-size: 1.1rem;
  color: #363636;
  margin-bottom: 0.5rem;
  text-align: right;
}

.textarea {
  width: 100%;
  resize: vertical;
  font-size: 1rem;
  border: 2px solid #dbdbdb;
  border-radius: 4px;
  padding: 0.75rem;
  transition: border-color 0.2s;
}

.textarea:focus {
  border-color: #f14668;
  outline: none;
  box-shadow: 0 0 0 3px rgba(241, 70, 104, 0.1);
}

.help.is-danger {
  color: #f14668;
  font-size: 0.9rem;
  margin-top: 0.25rem;
  text-align: right;
}

/* Summary section */
.summary-section {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border: 1px solid #e0e0e0;
}

.summary-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #363636;
  margin-bottom: 0.75rem;
  text-align: right;
}

.summary-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.summary-row {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  background: white;
  border-radius: 4px;
  text-align: right;
}

.summary-label {
  font-weight: 600;
  color: #555;
  min-width: 120px;
  margin-left: 0.75rem;
}

.summary-value {
  color: #363636;
  flex: 1;
}

/* Buttons section */
.buttons-section {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.button {
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  min-width: 150px;
}

.button.is-danger {
  background-color: #f14668;
  border-color: #f14668;
  color: white;
}

.button.is-danger:hover:not(:disabled) {
  background-color: #ef2e4a;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(241, 70, 104, 0.3);
}

.button.is-light {
  background-color: #f5f5f5;
  border-color: #dbdbdb;
  color: #363636;
}

.button.is-light:hover:not(:disabled) {
  background-color: #e8e8e8;
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button .icon {
  margin-left: 0.5rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .feed-error-report-modal {
    padding: 1rem;
  }

  .summary-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .summary-label {
    min-width: unset;
    margin-left: 0;
    margin-bottom: 0.25rem;
  }

  .buttons-section {
    flex-direction: column;
  }

  .button {
    width: 100%;
  }
}
</style>
